<div class="login">
    <div class="login-form">
        <h2>Login</h2>
        <div class="alert alert-success" *ngIf = "message">
                <div>{{message}}</div>
        </div>
        <form #f = 'ngForm' (ngSubmit) = "onSubmit(f)" action="#" class="pt-3 pb-3">
            <div class="input-group mb-3">
                <input type="email" required placeholder="email" ngModel name="email" #email = "ngModel" id="email" pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$">
            </div>
            <div class="alert alert-danger" *ngIf = "email.touched && !email.valid">
                <div *ngIf = "email.errors.required">Email is Required</div>
                <div *ngIf = "email.errors.pattern">Email Should Contain "@"</div>
            </div>
            <div class="input-group mb-3">
                <input [type]="fieldTextType ? 'text' : 'password'" required placeholder="password" ngModel name="password" #password = "ngModel" id="password" minlength = "6">
                <div class="input-group-append" style="cursor: pointer;">
                    <span class="input-group-text">
                        <i
                          class="fa"
                          [ngClass]="{
                            'fa-eye-slash': !fieldTextType,
                            'fa-eye': fieldTextType
                          }"
                          (click)="toggleFieldTextType()"
                        ></i>
                      </span>
                </div>
            </div>
            <div class="alert alert-danger" *ngIf = "(password.touched && password.invalid) || (password.touched && !password.valid)||(f.submitted && !password.touched) ">
                <div *ngIf="password.errors.minlength">Password must be at least 6 characters</div>
                <div *ngIf="password.errors.required">Password is required</div>
            </div>
            <div class="alert alert-danger" *ngIf = "res">
                <div>{{res}}</div>
            </div>
            <!-- <div class="forgot-psw pb-3">Forgot Password?</div> -->
            <button class="login-button" *ngIf="!dataLoading" [disabled]="!f.valid">Login</button>
            <p class="small mt-2">Forgot your password? Click <a routerLink="/reset-password">here</a> to reset.</p>
            <button *ngIf="dataLoading" disabled class="mt-1 no-border-button"><mat-spinner [diameter]="'27'"></mat-spinner></button>
            <div class="verify-account mt-5" *ngIf="showVerificationMessage">
                <p>Your account is not verified. To continue please verify your account from this <a [routerLink]="[url]" [queryParams]="{token: token, sendAgain: true}">link.</a></p>
            </div>
        </form>
    </div>
    <p class="login-register">Don't have an account yet?<br /> <a class="site-title" [routerLink]="['/register']">Signup</a> to start selling your property today!</p>
</div>
